var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9153 2.54785L7.92725 19.2765V52.7563L36.9153 69.485L65.9034 52.7563V19.2765L36.9153 2.54785ZM60.8375 20.2559L36.9153 34.0689L12.9931 20.2559L36.9153 6.44295L60.8375 20.2559ZM11.3045 23.1829L35.2267 36.9958V64.6105L11.3045 50.7975V23.1829ZM38.6039 64.6105V36.9958L62.5261 23.1829V50.7975L38.6039 64.6105Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.50d8ca0ae1f6a0baedc47cca7960fd70.svg";
export { ForwardRef as ReactComponent };